import React from "react";

function Sim({ width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 36 48"
    >
      <path
        fill="#fff"
        d="M13.5-19.5h-2.147A3.921 3.921 0 007.5-15.562V-12h6v-7.5zm-6 14.063A3.921 3.921 0 0011.353-1.5H19.5V-9h-12v3.563zm9-6.563h12v-3.562a3.956 3.956 0 00-4.022-3.938H16.5zm18.619-18.881L24.872-41.128A3 3 0 0022.753-42H6a6.018 6.018 0 00-6 6V0a6.018 6.018 0 006 6h24a6.018 6.018 0 006-6v-28.753a3.016 3.016 0 00-.881-2.128zM31.5 0A1.511 1.511 0 0130 1.5H6A1.511 1.511 0 014.5 0v-36A1.511 1.511 0 016-37.5h16.134l9.366 9.366zm-9-1.5h1.978A3.956 3.956 0 0028.5-5.437V-9h-6z"
        data-name="Path 2249"
        transform="translate(0 42)"
      ></path>
    </svg>
  );
}

export default Sim;
